import { render, staticRenderFns } from "./Commissioni.vue?vue&type=template&id=0b461f06&scoped=true&"
import script from "./Commissioni.vue?vue&type=script&lang=ts&"
export * from "./Commissioni.vue?vue&type=script&lang=ts&"
import style0 from "./Commissioni.vue?vue&type=style&index=0&id=0b461f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b461f06",
  null
  
)

export default component.exports